import {
  TileFolderIconContainer,
  ProjectTileCardContainer,
  TitleTitle,
  TileDescription,
  MetaDataContainer,
  MetaDataItemContainer,
  MetaDataText,
  TileTextContainer,
  RoleBagdeContainer
} from './styled-component'
import { Folder, Pins, Task } from '../stories/atoms/icons/entities'
import { LastActivity } from '../stories/atoms/icons/core'
import { iconSizeOptions } from '../stories/atoms/icons/icons-sizes'
import ProjectTileCardHeader from './project-tile-card-header'
import { projectsAPI } from '../../../proxyConfig/apiUrls'
import { useIntl } from 'react-intl'
import { useAccessSearchParam } from '../../zustand/authentication/use-auth-store'
import { projectListTabOption } from './constants'
import { handleRoleColor } from '../../components/copy-project-modal/constants'
import {
  badgeSizeOptions,
  badgesVariantOptions
} from '../stories/atoms/badges/constants'
import BadgesComponent from '../stories/atoms/badges'
import { formatRelativeDate } from '../../utils/format-relative-date'

const defaultMetaData = {
  openPins: 0,
  openTasks: 0,
  lastActivity: null
}

const MetaDataItem = ({ text, icon, disabled }) => {
  return (
    <MetaDataItemContainer disabled={disabled}>
      {icon}
      <MetaDataText disabled={disabled}>{text}</MetaDataText>
    </MetaDataItemContainer>
  )
}

const ProjectTileCard = ({
  item,
  role = null,
  isFolder = false,
  userPermissions = null,
  metaData = defaultMetaData,
  projectListOption = projectListTabOption.MY_PROJECTS,
  onLeaveProject = () => {},
  disabled = false,
  ...props
}) => {
  const { formatMessage, locale } = useIntl()
  const accessToken = useAccessSearchParam()
  const hasMetaData = Object.values(metaData).some((value) => value !== null)
  const image = `${projectsAPI}/${item.id}/logo${accessToken()}`
  const isMyProjectList = projectListOption === projectListTabOption.MY_PROJECTS

  const roleType = item.role?.type
  const roleName = item.role?.name
  const roleLabel = roleType
    ? formatMessage({
        id: `personas_roleLabel${roleType}`,
        defaultMessage: roleName ?? roleType
      })
    : (roleName ?? '')

  // handlers
  const getFolderText = (items) => {
    const key = items === 1 ? 'projects_items1' : 'projects_itemsOther'
    return `${items} ${formatMessage({ id: key })}`
  }

  const description = isFolder ? getFolderText(item.items) : item.companyName

  return (
    <ProjectTileCardContainer {...props}>
      {isFolder ? (
        <TileFolderIconContainer>
          <Folder style={{ width: '144px', height: '144px' }} />
        </TileFolderIconContainer>
      ) : (
        <ProjectTileCardHeader
          item={item}
          image={image}
          userPermissions={userPermissions}
          projectListOption={projectListOption}
          onLeaveProject={onLeaveProject}
          disabled={disabled}
        />
      )}
      <TileTextContainer>
        {roleLabel && (
          <RoleBagdeContainer>
            <BadgesComponent
              variant={badgesVariantOptions.STRONG}
              size={badgeSizeOptions.SMALL}
              color={handleRoleColor(roleType)}
              disabled={disabled}
            >
              {roleLabel}
            </BadgesComponent>
          </RoleBagdeContainer>
        )}
        <TitleTitle disabled={disabled}>{item.name}</TitleTitle>
        {description && (
          <TileDescription disabled={disabled}>{description}</TileDescription>
        )}
      </TileTextContainer>
      {hasMetaData && (
        <MetaDataContainer>
          {isMyProjectList && (
            <>
              <MetaDataItem
                text={metaData.openPins}
                icon={<Pins size={iconSizeOptions['ICON-S']} />}
                disabled={disabled}
              />
              <MetaDataItem
                text={metaData.openTasks}
                icon={<Task size={iconSizeOptions['ICON-S']} />}
                disabled={disabled}
              />
            </>
          )}
          <MetaDataItem
            text={formatRelativeDate(
              metaData.lastActivity,
              locale,
              formatMessage
            )}
            icon={<LastActivity size={iconSizeOptions['ICON-S']} />}
            disabled={disabled}
          />
        </MetaDataContainer>
      )}
    </ProjectTileCardContainer>
  )
}

export default ProjectTileCard
